import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-700c0fed"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-popup" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "title-wrapper" }
const _hoisted_4 = { class: "title-text" }
const _hoisted_5 = { class: "sub-title" }
const _hoisted_6 = { class: "block-btns" }
const _hoisted_7 = ["onClick"]

import {
  ref,
} from 'vue';

type InfoType = 'baseInfo' | 'camera';

interface IPopupProps {
  isShowInfoTypeBtn: boolean
  baseInfo: IPartialUnionBaseInfo;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    isShowInfoTypeBtn: { type: Boolean },
    baseInfo: null
  },
  emits: ['close', 'change'],
  setup(__props: any, { emit: emits }) {

/* eslint-disable line-comment-position, no-inline-comments, comma-dangle, no-undef */



const currentInfoType = ref<InfoType>('baseInfo'); // 展示信息的类别
/**
 * 弹窗信息类型的映射关系
 */
const infoTypeMap: Record<InfoType, string> = {
  baseInfo: '基本信息',
  camera: '视频监控'
};

const handleClose = () => {
  emits('close');
};

const handleChange = (type: InfoType) => {
  currentInfoType.value = type;
  emits('change', type);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(__props.baseInfo.name || __props.baseInfo.companyName), 1),
        _createElementVNode("div", _hoisted_5, _toDisplayString(__props.baseInfo.address), 1),
        _createElementVNode("div", {
          class: "iconfont icon-close close",
          onClick: handleClose
        }),
        _withDirectives(_createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(infoTypeMap), (infoType, index) => {
            return (_openBlock(), _createElementBlock("div", {
              onClick: ($event: any) => (handleChange(infoType as InfoType)),
              key: index,
              class: _normalizeClass(['btn', currentInfoType.value === 'baseInfo'?'active':''])
            }, _toDisplayString(infoTypeMap[infoType]), 11, _hoisted_7))
          }), 128))
        ], 512), [
          [_vShow, __props.isShowInfoTypeBtn]
        ])
      ])
    ]),
    _renderSlot(_ctx.$slots, "detail"),
    _renderSlot(_ctx.$slots, "content")
  ]))
}
}

})